import React, { useContext } from "react";
import AuthUserCard from "components/AuthUserCard/AuthUserCard";
import CustomizeIcon from "components/Icons/CustomizeIcon";
import DarkThemeIcon from "components/Icons/DarkThemeIcon";
import LightThemeIcon from "components/Icons/LightThemeIcon";
import MoonIcon from "components/Icons/MoonIcon";
import SunIcon from "components/Icons/SunIcon";
import {
  CardBody,
  CardHead,
  FormBody,
  FormHead,
  ParaSm,
} from "components/SelectTheme/SelectTheme.style";
import { AccInfoWrapper, Heading5, Heading6 } from "config/global.style";
import { Col, Row, Radio } from "antd";
import { ThemeContext } from "context/themeContext";
import SystemPrefIcon from "components/Icons/SystemPrefIcon";

const SelectTheme: React.FC = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <AccInfoWrapper className="w-100">
      <Heading5 className="heading5">Theme</Heading5>
      <FormHead>
        <Heading6 className="heading6">Interface theme</Heading6>
        <ParaSm>Select or customize your UI theme.</ParaSm>
      </FormHead>
      <FormBody>
        <Row gutter={24}>
          <Radio.Group
            className="themecardwrapper"
            value={theme}
            onChange={(e) =>
              setTheme(e.target.value as "SYSTEM_PREFRENCE" | "LIGHT" | "DARK")
            }
          >
            <Col xs={24} sm={12}  lg={8}>
              <Radio.Button className="cardbtn" value="SYSTEM_PREFRENCE">
                <AuthUserCard className="themecard">
                  <CardHead>
                    <CustomizeIcon />
                    <Heading6 className="cardtitle">System Preference</Heading6>
                    {theme === "SYSTEM_PREFRENCE" && (
                      <span className="activebox">Active</span>
                    )}
                  </CardHead>
                  <CardBody>
                    <ParaSm>
                      This theme will activate based on your system preference.
                    </ParaSm>
                    <div className="themepreview">
                      <SystemPrefIcon />
                    </div>
                  </CardBody>
                </AuthUserCard>
              </Radio.Button>
            </Col>
            <Col xs={24} sm={12}  lg={8}>
              <Radio.Button className="cardbtn" value="LIGHT">
                <AuthUserCard className="themecard">
                  <CardHead>
                    <SunIcon />
                    <Heading6 className="cardtitle">Light theme</Heading6>
                    {theme === "LIGHT" && (
                      <span className="activebox">Active</span>
                    )}
                  </CardHead>
                  <CardBody>
                    <ParaSm>
                      This theme will activate when you select light mode.
                    </ParaSm>
                    <div className="themepreview">
                      <LightThemeIcon />
                    </div>
                  </CardBody>
                </AuthUserCard>
              </Radio.Button>
            </Col>
            <Col xs={24} sm={12}  lg={8}>
              <Radio.Button className="cardbtn" value="DARK">
                <AuthUserCard className="themecard">
                  <CardHead>
                    <MoonIcon />
                    <Heading6 className="cardtitle">Dark theme</Heading6>
                    {theme === "DARK" && (
                      <span className="activebox">Active</span>
                    )}
                  </CardHead>
                  <CardBody>
                    <ParaSm>
                      This theme will activate when you select dark mode.
                    </ParaSm>
                    <div className="themepreview">
                      <DarkThemeIcon />
                    </div>
                  </CardBody>
                </AuthUserCard>
              </Radio.Button>
            </Col>
          </Radio.Group>
        </Row>
      </FormBody>
    </AccInfoWrapper>
  );
};

export default SelectTheme;
